/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
    'kanban-fill': {
        width: 16,
        height: 16,
        viewBox: '0 0 16 16',
        data: '<path pid="0" d="M2.5 0a2 2 0 00-2 2v12a2 2 0 002 2h11a2 2 0 002-2V2a2 2 0 00-2-2zm5 2h1a1 1 0 011 1v3a1 1 0 01-1 1h-1a1 1 0 01-1-1V3a1 1 0 011-1m-5 1a1 1 0 011-1h1a1 1 0 011 1v7a1 1 0 01-1 1h-1a1 1 0 01-1-1zm9-1h1a1 1 0 011 1v10a1 1 0 01-1 1h-1a1 1 0 01-1-1V3a1 1 0 011-1"/>',
    },
});
